import React from 'react';
import { defineMessages, useIntl } from 'react-intl';
import { useSelector } from 'react-redux';
import { styled } from '@linaria/react';
import { GetTheAppButtons } from 'components/GetTheAppButtons/GetTheAppButtons';
import Settings from 'Settings';
import { getLanguageCode } from 'utils/localization/language';
import { useDeviceLayout } from '@daedalus/atlas/context/deviceLayout';
import ContentWrapper from '@daedalus/atlas/helpers/ContentWrapper';
import { Flex } from '@daedalus/atlas/helpers/Flex';
import { PageWidthContainer } from '@daedalus/atlas/helpers/PageWidthContainer';
import { Icon } from '@daedalus/atlas/Icon';
import { Text } from '@daedalus/atlas/Text';
import { Placement } from '@daedalus/core/src/deepLinking/types';
import { AppRatingsAndReviews } from '../AppRatingsAndReviews';
import { HighlightedTitle } from '../HighlightedTitle';
const Container = /*#__PURE__*/styled('div')({
  name: "Container",
  class: "c1nhpxrm",
  propsAsIs: false
});
const SectionWrapper = /*#__PURE__*/styled('div')({
  name: "SectionWrapper",
  class: "s15dfwy",
  propsAsIs: false
});
const GetAppWrapper = /*#__PURE__*/styled('div')({
  name: "GetAppWrapper",
  class: "g5hlbmq",
  propsAsIs: false
});
const _exp6 = /*#__PURE__*/() => Text;
const Title = /*#__PURE__*/styled(_exp6())({
  name: "Title",
  class: "tbs8g7v",
  propsAsIs: true
});
const _exp11 = /*#__PURE__*/() => Text;
const AdvantageItemText = /*#__PURE__*/styled(_exp11())({
  name: "AdvantageItemText",
  class: "a1879qcd",
  propsAsIs: true
});
const _exp13 = /*#__PURE__*/() => Flex.Row;
const AppStoreWrapper = /*#__PURE__*/styled(_exp13())({
  name: "AppStoreWrapper",
  class: "a1uw0jrw",
  propsAsIs: true
});
const _exp17 = /*#__PURE__*/() => Flex.Column;
const PrintScreensLeft = /*#__PURE__*/styled(_exp17())({
  name: "PrintScreensLeft",
  class: "pks45g9",
  propsAsIs: true
});
const _exp19 = /*#__PURE__*/() => Flex.Column;
const PrintScreensRight = /*#__PURE__*/styled(_exp19())({
  name: "PrintScreensRight",
  class: "p1alhp0o",
  propsAsIs: true
});
const _exp21 = /*#__PURE__*/() => ({
  src
}) => `url(${src})`;
const PrintScreen = /*#__PURE__*/styled('div')({
  name: "PrintScreen",
  class: "pq4iuia",
  propsAsIs: false,
  vars: {
    "pq4iuia-0": [_exp21()]
  }
});
const advantages = defineMessages({
  saveUpToSixty: {
    id: 'homePage.appAdvantagesSaveUpTo',
    defaultMessage: 'Save up to 60%'
  },
  manageYourReservation: {
    id: 'homePage.appAdvantagesManageBookings',
    defaultMessage: 'Manage your bookings'
  },
  trackPrices: {
    id: 'homePage.trackPrices',
    defaultMessage: 'Track prices'
  }
});
const appAdvantageItems = [advantages.saveUpToSixty, advantages.manageYourReservation, advantages.trackPrices];
export const MobileAppSection = () => {
  const {
    isMobile
  } = useDeviceLayout();
  const {
    formatMessage
  } = useIntl();
  const languageCode = useSelector(getLanguageCode);
  return <Container>
      <SectionWrapper>
        <PageWidthContainer>
          <ContentWrapper paddingX={isMobile ? 's600' : 's950'}>
            <Flex.Row justifyContent="space-between" alignItems="flex-start" gap="s600">
              <GetAppWrapper>
                <Title variant={isMobile ? 'title2XL' : 'title4XL'}>
                  <HighlightedTitle source="UnlockExclusiveSavings" />
                </Title>

                <Flex.Column gap="s300">
                  {appAdvantageItems.map((text, index) => <Flex.Row alignItems="center" key={index} gap="s300">
                      <Icon name="Checkmark" colorPath="content.highlight.c500" />
                      <AdvantageItemText variant={isMobile ? 'bodyM' : 'bodyL'}>
                        {formatMessage(text)}
                      </AdvantageItemText>
                    </Flex.Row>)}
                </Flex.Column>

                <ContentWrapper paddingTop={isMobile ? 's700' : 's900'}>
                  <GetTheAppButtons placement={Placement.HomePageAppSection} />
                </ContentWrapper>

                <AppStoreWrapper alignItems="center" justifyContent="flex-start" gap="s700">
                  <AppRatingsAndReviews variant="AppStore" />
                  <AppRatingsAndReviews variant="GooglePlay" />
                </AppStoreWrapper>
              </GetAppWrapper>

              {!isMobile && <Flex.Row justifyContent="space-between" alignItems="flex-end" gap="s700">
                  <PrintScreensLeft justifyContent="space-between" alignItems="center" gap="s700">
                    <PrintScreen src={`${Settings.get('CLIENT_STATIC_ASSETS_ENDPOINT')}HomePage/${languageCode}/iphone-map.webp`} />
                    <PrintScreen src={`${Settings.get('CLIENT_STATIC_ASSETS_ENDPOINT')}HomePage/${languageCode}/iphone-your-stays.webp`} />
                  </PrintScreensLeft>
                  <PrintScreensRight justifyContent="space-between" alignItems="center" gap="s700">
                    <PrintScreen src={`${Settings.get('CLIENT_STATIC_ASSETS_ENDPOINT')}HomePage/${languageCode}/iphone-srp.webp`} />
                    <PrintScreen src={`${Settings.get('CLIENT_STATIC_ASSETS_ENDPOINT')}HomePage/${languageCode}/iphone-ap.webp`} />
                  </PrintScreensRight>
                </Flex.Row>}
            </Flex.Row>
          </ContentWrapper>
        </PageWidthContainer>
      </SectionWrapper>
    </Container>;
};

require("./MobileAppSection.wyw-in-js.css!=!../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./MobileAppSection.tsx");